import React from 'react';
import PropTypes from 'prop-types';
import { Close as CloseIcon } from '@mui/icons-material';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import { Button } from '@atoms';
import styles from './styles';

/**
 * Custom Message Popup with RC
 */
const CustomMessagePopup = ({
  isOpen,
  onClose,
  title,
  message,
  showCloseButton = true,
  showConfirmButton = true,
  confirmButtonText = 'Entendido',
  onConfirm,
  customStyles = {},
}) => {
  /** HandlerConfirm */
  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    onClose();
  };

  /** No cerrar por clic en backdrop ni por tecla Escape */
  const handleDialogClose = (_event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleDialogClose}
      maxWidth='sm'
      fullWidth
      PaperProps={{
        sx: {
          ...styles.dialogPaper,
          ...customStyles.paper,
        },
      }}
    >
      <DialogTitle sx={styles.dialogTitle}>
        <Box sx={styles.titleContainer}>
          <Typography variant='h6' component='div' sx={styles.title}>
            {title}
          </Typography>
          {showCloseButton && (
            <IconButton aria-label='cerrar' onClick={onClose} sx={styles.closeButton}>
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      </DialogTitle>

      <DialogContent sx={styles.dialogContent}>
        <Typography variant='body1' sx={{ ...styles.message, ...customStyles.message }}>
          {message}
        </Typography>
      </DialogContent>

      {showConfirmButton && (
        <DialogActions sx={styles.dialogActions}>
          <Button
            onClick={handleConfirm}
            text={confirmButtonText}
            variant='contained'
            customStyle={{ button: styles.confirmButton }}
          />
        </DialogActions>
      )}
    </Dialog>
  );
};

CustomMessagePopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  showCloseButton: PropTypes.bool,
  showConfirmButton: PropTypes.bool,
  confirmButtonText: PropTypes.string,
  onConfirm: PropTypes.func,
  customStyles: PropTypes.object,
};

export default CustomMessagePopup;
